import {
  mdiLayers,
  mdiPlusCircle,
  mdiAccount,
  mdiAirplaneTakeoff,
  mdiUpload,
  mdiComma
} from "@mdi/js"
import store from "../store"
import router from "../router"
import {CLEAN_PROCESSING} from "../store/modules/processing"

export const MenuList = [
  {
    "path": "/app/processing",
    "name": "Novo Processamento",
    "normalized_name": "processing",
    "icon": mdiPlusCircle,
    "mobile": false,
    "onClick": () => {
      store.dispatch(CLEAN_PROCESSING)
        .then(() => {
          router.push("/app/processing", () => {})
        })
    },
  },
  {
    "path": "/app/processing-list",
    "name": "Meus Processamentos",
    "normalized_name": "processing_list",
    "icon": mdiLayers,
    "mobile": true,
    "onClick": () => {
      router.push("/app/processing-list", () => {})
    },
  },
  {
    "path": "/app/my-account",
    "name": "Minha conta",
    "normalized_name": "my_account",
    "icon": mdiAccount,
    "mobile": true,
    "onClick": () => {
      router.push("/app/my-account", () => {})
    },
  },
  {
    "path": "/app/accredited-register",
    "name": "Serviços",
    "normalized_name": "accredited-register",
    "icon": mdiAirplaneTakeoff,
    "mobile": true,
    "onClick": () => {
      router.push("/app/accredited-register", () => {})
    },
  },
]

export const MenuListAdmin = [
  {
    "path": "/app/manual-uploads",
    "name": "Uploads manuais",
    "normalized_name": "manual-uploads",
    "icon": mdiUpload,
    "mobile": true,
    "onClick": () => {
      router.push("/app/manual-uploads", () => {})
    },
  },
  {
    "path": "/app/news",
    "name": "Novidades",
    "normalized_name": "news",
    "icon": mdiComma,
    "mobile": true,
    "onClick": () => {
      router.push("/app/news", () => {})
    },
  },  
]
